<template>
  <div class="section">
    <div id="alertTokenReminder" class="modal fade" tabindex="-1" role="dialog" style="display: none;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span aria-hidden="true">×</span></button>
            <h4 id="forgot_ModalLabel" class="modal-title"><i class="fa fa-bullhorn mr-5"></i>{{'amazon_merchant_order'|translate}}</h4>
          </div>
          <div class="modal-body">
            <b-alert :show="alert.dismiss" :variant="alert.type">
              <h4>
                <i :class="['icon', alert.icon]"></i>
                {{alert.title}}</h4>
              <p class="message">
                <span>{{'create_new_amazon_merchant_order_token'|translate}}</span>
              </p>
            </b-alert>
          </div>
        </div>
      </div>
    </div>
    <button id="openTokenReminder" hidden data-toggle="modal" data-target="#alertTokenReminder"></button>
  </div>
</template>
<script>
export default {
  data () {
    return {
      alert: {}
    }
  },
  methods: {
    getData () {
      API.get(`observation/amazon/tokenExpirationDate`, {})
        .then(res => {
          if (res.data && Object.keys(res.data).length > 0) {
            let expirationDate = moment(res.data.expiration_date)
            let today = moment().startOf('day')
            if (expirationDate.subtract(2, 'weeks') < today) {
              this.alert = {
                type: 'danger',
                icon: 'fa fa-warning',
                dismiss: true,
                message: '',
                title: 'ACHTUNG'
              }
              $('#openTokenReminder').click()
            }
          }
        })
    }
  },
  mounted () {
    this.getData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/AmazonTokenRenewalReminder.vue